/**
 * Shared constants for job-related dropdown options.
 * These values must match the Android app (AppConstants.kt).
 *
 * IMPORTANT: If you modify these values, also update:
 * - Android: AppConstants.kt (WASTE_TYPES, SKIP_SIZES, etc.)
 */

export const WASTE_TYPES = [
    'General / Mixed',
    'Wood',
    'Hardcore / Rubble',
    'Plasterboard',
    'Greens',
    'Metal',
    'Unknown'
];

export const SKIP_SIZES = [
    '2yd',
    '4yd',
    '6yd',
    '8yd',
    '8yd lock',
    '10yd',
    '12yd',
    '12yd lock',
    '14yd',
    '14yd lock',
    '16yd',
    '16yd lock',
    '20yd',
    '40yd'
];

export const JOB_TYPES = [
    'Delivery',
    'Collection',
    'Exchange',
    'Other'
];

export const JOB_STATUSES = [
    'delivered',
    'collected'
];

export const PAYMENT_STATUSES = [
    'Paid',
    'TO PAY',
    'Account',
    'Unknown'
];
